import businessClient from 'src/services/clients/business'
import { IMeta, ITemplate } from 'src/common/interfaces/index.js'

const ISettingsTagListResponse = { meta: IMeta, data: { upsert: [ITemplate] } }

export const settingsTemplate = {
  /**
   * @param {id: number} filter
   * @return {ISettingsTagListResponse}
   */
  list(filter, signal) {
    return businessClient().post('settings/templates/portal/list', { filter }, { signal })
  },
  /**
   * @param {id: number} filter
   * @return {ISettingsTagListResponse}
   */
  archive(filter, signal) {
    return businessClient().post('settings/templates/archive', { filter }, { signal })
  },

  /**
   * @param {ITemplate} data
   * @return {ISettingsTagListResponse}
   */
  upsert(data, signal) {
    return businessClient().post('settings/templates/upsert', { data }, { signal })
  },
}
